var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplateIcon = function SvgTemplateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 17,
    viewBox: "0 0 13 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 16c0-.003 11.001 0 11.001 0L12 1C12 1.003.999 1 .999 1zM.999 0H12c.552 0 .999.455.999 1v15a1 1 0 0 1-.999 1H1C.447 17 0 16.545 0 16V1a1 1 0 0 1 .999-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4h.5V3H0v1h.5zM2 6l1-1v10l-1-1h4l-1 1V5l1 1zm4-1v10H2V5zm1 1 1-1v4L7 8h4l-1 1V5l1 1zm4-1v4H7V5zm-4 6 1-1v5l-1-1h4l-1 1v-5l1 1zm4-1v5H7v-5z"
  }))));
};
export default SvgTemplateIcon;